import IndexManagement from "../../modules/management/Index.vue";

const routes = [
    { 
        path: '/gestion', 
        component: IndexManagement
    },
];

export default routes;